<template>
  <Layout>
    <template #header-container>
      <PageHeader
        class="mc-page-three"
        hasBreadcrumb
        isSticky
        :title="title"
        :subTitle="subTitle"
        :items="breadcrumbItems"
      >
        <template #afterTitle>
          <div class="d-flex gap-2">
            <McButtonBack />
            <McButton v-if="isTableDataAvailable" text="Tambah" icon="icon-fill_plus" @click="handleAdd" />
          </div>
        </template>
      </PageHeader>
    </template>
    <McTable
      v-show="isTableDataAvailable"
      searchable
      withCard
      bulkDeleteApi
      class="template-delivery-table"
      :fields="fields"
      :apiClient="apiClient"
      @available-change="isTableDataAvailable = $event"
    >
      <template #cell(name)="{ item, value }">
        <div class="text-primary primary-field">
          <div @click="handleClickRow(item)">
            {{ value }}
          </div>

          <i v-if="item.is_error" class="icon-fill_alert-circle"/>
        </div>
      </template>
      <template #cell(description)="{ value }">
        {{ value || '-' }}
      </template>
      <template #cell(created_on)="{ value }">
        <template>
          <div>{{ formatIndexDate(value).date }}</div>
          <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
        </template>
      </template>
    </McTable>
    <b-card v-show="!isTableDataAvailable" class="empty-table-container">
      <McEmptyState
        title="Belum ada data template pengiriman"
        desc="Tambahkan data terlebih dulu ya!"
        @buttonPrimaryAction="handleAdd"
      />
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McTable from '@/components/McTable'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import McEmptyState from '@/components/McEmptyState'

import * as TemplateDeliveryOrder from '@/services/rest-api/lib/delivery/template'
import { formatIndexDate } from '@/helpers/tzDate'

import { templateListFields } from './lib/fields/template-list-fields.js'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McTable,
    McButtonBack,
    McButton,
    McEmptyState,
  },
  data() {
    return {
      isTableDataAvailable: true,
    }
  },
  computed: {
    title() {
      return 'Pengiriman'
    },
    subTitle() {
      return 'Mengelola template untuk pengiriman.'
    },
    breadcrumbItems() {
      return [
        {
          text: 'Pengaturan',
          to: '/setting',
        },
        {
          text: 'Template',
          to: '/setting/subsetting',
        },
        {
          text: this.title,
        },
      ]
    },
    apiClient() {
      return {
        get: TemplateDeliveryOrder.get(),
        delete: TemplateDeliveryOrder.deleteMany,
      }
    },
    fields() {
      return templateListFields
    },
  },
  methods: {
    formatIndexDate,
    handleAdd() {
      this.$router.push({ name: 'Setting Template Delivery Order Create' })
    },
    handleClickRow(item) {
      this.$router.push({ name: 'Setting Template Delivery Order Detail', params: { id: item.id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.template-delivery-table {
  .primary-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    i {
      font-size: 16px;

      &:before {
        color: $red;
      }
    }
  }
}
</style>